module.exports = __webpack_public_path__ + "static/media/15_r_stena_83.75_0.5a5d19a3.png";